import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import PageHeader from '../../components/PageHeader';
import styles from './BranchHelp.module.css';

export default function BranchHelp() {
  const [faqs,   setFaqs]   = useState([]);
  const [openId, setOpenId] = useState(null);

  // Load FAQs from Firestore (managed by admin)
  useEffect(() => {
    const q = query(collection(db, 'faqs'), orderBy('createdAt', 'asc'));
    return onSnapshot(q, snap => {
      if (!snap.empty) setFaqs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
  }, []);

  return (
    <div className={styles.page}>
      <PageHeader
        title="Help Center"
        description="Browse FAQs and track your support tickets"
      />

      <div className={styles.faqList}>
        {faqs.length === 0 && <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>FAQs are loading…</p>}
        {faqs.map(faq => (
          <div key={faq.id} className={styles.faqItem}>
            <button
              className={styles.faqHeader}
              onClick={() => setOpenId(prev => prev === faq.id ? null : faq.id)}
              aria-expanded={openId === faq.id}
            >
              <span className={styles.faqQuestion}>{faq.question}</span>
              <span className={styles.faqChevron}>{openId === faq.id ? '▲' : '▼'}</span>
            </button>
            {openId === faq.id && (
              <div className={styles.faqBody}>
                <p className={styles.faqAnswer}>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  );
}
